import React from 'react';
import PropTypes from 'prop-types';
import graphql from "babel-plugin-relay/macro";
import {useFragment, useMutation} from "react-relay";
import {createOptions} from "../../../helpers/utils";
import {allContactPointSystemCodesDropdown, allContactPointUseCodesDropdown} from "../../../relay/Fragments";
import dayjs from "dayjs";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import FormModal from "../../../components/common/modals/FormModal";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema} from "../../../helpers/bandedUtils";

const EditFacilityContactPointModal = ({showModal, onClose, selectedContactPoint, systemCodes, useCodes}) => {
    const mutation = graphql`
    mutation EditFacilityContactPointModalMutation($facilityContactPointId: ID!, $contactPointSystemId:ID!, $contactPointUseId: ID!,
    $value: String!, $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
        facility {
            modifyContactPoint(input: {facilityContactPointId: $facilityContactPointId, contactPointSystemId: $contactPointSystemId,
            contactPointUseId: $contactPointUseId, value: $value, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                facilityContactPoint {
                    id
                    facility {
                        contactPoints {
                            ...FacilityContactPoints_ContactPoints
                        }}}}}}`
    const contactPointSystem = createOptions(useFragment(allContactPointSystemCodesDropdown, systemCodes), 'id', 'display');
    const contactPointUse = createOptions(useFragment(allContactPointUseCodesDropdown, useCodes), 'id', 'display');
    const [commitMutation, isInFlight] = useMutation(mutation);
    const effectiveFrom = selectedContactPoint?.effectiveFrom ? dayjs(selectedContactPoint?.effectiveFrom).toDate() : '';
    const effectiveTo = selectedContactPoint?.effectiveTo ? dayjs(selectedContactPoint?.effectiveTo).toDate() : '';
    const defaultValues = {
        facilityContactPointId: selectedContactPoint?.id,
        contactPointUseId: selectedContactPoint.contactPointUseCode.id,
        contactPointSystemId:selectedContactPoint.contactPointSystemCode.id,
        value: selectedContactPoint.value,
        effectiveFrom: effectiveFrom,
        effectiveTo: effectiveTo
    }
    const schema = bandedSchema.shape({
        contactPointSystemId: yup.string().required("System Code is required"),
        contactPointUseId: yup.string().required("Use Code is required"),
        value: yup.string().required("Value is required")
    });
    const methods = useForm({values: defaultValues, resolver: yupResolver(schema)});

    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.facility) {
                    toast.success("Contact Point for Facility updated")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal} 
                   onClose={onClose}
                   title={"Update Contact Point"}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit} 
                   methods={methods}
        >
            <HorizontalFormSelect options={contactPointSystem} controlId={"contactPointSystemId"} label={"System Code"} />
            <HorizontalFormSelect options={contactPointUse} controlId={"contactPointUseId"} label={"Use Code"} />
            <HorizontalFormInput controlId={"value"} label={"Value"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
EditFacilityContactPointModal.propTypes = {}
export default EditFacilityContactPointModal